import React from 'react';
import './selected-item-details.scss';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Rating } from '@thd-olt-component-react/core-ui';
import { Price } from '@thd-olt-component-react/price';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { bool, string, shape } from 'prop-types';
import { ProductDetailsButton } from './ProductDetailsButton';

const SelectedItemDetails = (props) => {
  const {
    itemId,
    storeId,
    channel,
    displayMobile,
    dataSource = 'catalog',
    data,
  } = props;

  const {
    reviews = {},
    identifiers = {},
  } = data || {};

  const { averageRating, totalReviews } = reviews.ratingsReviews || {};
  const { modelNumber, canonicalUrl, brandName, productLabel } = identifiers;

  const mountedFn = () => {
    return storeId !== '8119';
  };

  if (storeId === '8119' && !data.itemId) return null;

  return (
    <QueryProvider
      mounted={mountedFn}
      dataSource={dataSource}
      defaultVariables={{ itemId, storeId }}
      cacheKey="selected-item-details"
    >
      <div className="bundling-product-tabs__info" data-testid="selected-item-details">
        <div className="bundling-product-tabs__reviews-and-favorites">
          <a href={canonicalUrl} className="bundling-product-tabs__reviews">
            <div className="bundling-product-tabs__reviews-container">
              <Rating value={parseFloat(averageRating)} type="stars" orange />
              <span className="bundling-product-tabs__reviews-container-total">({totalReviews})</span>
            </div>
            <span className="bundling-product-tabs__review-divider">|</span>
            <div className="bundling-product-tabs__reviews-container-model">Model # {modelNumber}</div>
          </a>
          <div className="bundling-product-tabs__favorites">
            <Favorite showCircle={false} itemId={itemId} storeId={storeId} />
          </div>
        </div>
        <div className="bundling-product-tabs__branding">
          <a href={canonicalUrl}>
            <span className="bundling-product-tabs__branding-brand">{brandName}</span>
            <span className="bundling-product-tabs__branding-product">{productLabel}</span>
          </a>
        </div>
        <div className="bundling-product-tabs__pricing">
          <Price itemId={itemId} channel={channel} storeId={storeId} displayEachUom={false} omitDetails />
        </div>
        <div className="bundling-product-tabs__specs">
          <p className="bundling-product-tabs__specs-title">Top Specs</p>
          <KeyProductFeatures
            itemId={itemId}
            hideImage
            maxfeatures={6}
            twoColumnGrid={!displayMobile}
            oneColumnGrid={displayMobile}
            displaySimilarLinks={false}
            simple
          />
        </div>
        <ProductDetailsButton itemId={itemId} />
      </div>
    </QueryProvider>
  );
};

SelectedItemDetails.displayName = 'SelectedItemDetails';

SelectedItemDetails.propTypes = {
  itemId: string,
  storeId: string,
  channel: string,
  displayMobile: bool,
  dataSource: string,
  data: shape({})
};

SelectedItemDetails.defaultProps = {
  itemId: '',
  storeId: '',
  channel: '',
  displayMobile: false,
  dataSource: 'catalog',
  data: {}
};

export { SelectedItemDetails };
